const ProfilePage = function() : void {
    const imageInput = document.getElementById('ProfileImage');
    const imageSizeWarning = <HTMLElement>document.getElementById('image-size-warning');
    
    if (imageInput) {
        imageInput.addEventListener("change", evt => {
            const preview = <HTMLImageElement>document.getElementById("uploadPreview");
            const imageElement = <HTMLInputElement>document.getElementById("ProfileImage");

            if (imageElement == null || imageElement.files == null)
                return;

            const image = imageElement.files[0];
            
            // Image size must be under 10MB
            if (image.size > 10 * 1024 * 1024) {
                imageSizeWarning.innerText = "Billede skal være mindre end 10MB";
                return;
            }
            else {
                imageSizeWarning.innerText = "";
            }
            preview.src = window.URL.createObjectURL(image);
            
        });
    }
}

export default ProfilePage;